<template>
    <label
        v-bind="$attrs"
        class="text-sm text-gray-600 flex items-center"
    >
        <slot />
        <span
            :class="{ invisible: !required }"
            class="text-red-500 text-lg"
        >
            *
        </span>
    </label>
</template>

<script setup lang="ts">
    defineProps({
        required: {
            type: Boolean,
            default: false,
        },
    })
</script>
